const MAX_PAGES = 7;

export interface IPageCounter {
	label: string,
	page: number,
	active: boolean
}

export function buildPaginationArray(currentPage, totalPages) {
	let pagination: IPageCounter[] = [];

	for (let i = 0; i < totalPages; i++) {
		pagination.push({
			label: (i + 1).toString(),
			page: i,
			active: i === currentPage
		});
	}
	// To stop the result set from looking messy, we'll trim the results if there are more than 5 pages
	if (totalPages > 7) {
		let tmpArray = [];

		// If we're near the beginning, show the first 4 results and the last one
		if (currentPage < 4) {
			tmpArray = pagination.slice(0, 6);
			tmpArray.push({
				label: '\u2026',
				page: null,
				active: false
			});
			tmpArray.push(pagination[pagination.length - 1]);
			pagination = tmpArray;
		} else if (currentPage > (totalPages - 4)) {
			// If we're near the end, show the first page and the last 4
			tmpArray = pagination.slice(-6);
			tmpArray.unshift({
				label: '\u2026',
				page: null,
				active: false
			});
			tmpArray.unshift(pagination[0]);
			pagination = tmpArray;
		} else {
			// If we're in the middle, output the first, last, and the two on either side of the current page
			tmpArray = pagination.slice(currentPage - 2, currentPage + 3);
			tmpArray.unshift({
				label: '\u2026',
				page: null,
				active: false
			});
			tmpArray.unshift(pagination.shift());
			tmpArray.push({
				label: '\u2026',
				page: null,
				active: false
			});
			tmpArray.push(pagination.pop());
			pagination = tmpArray;
		}
	}

	return pagination;
}
